import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/MVP.vue'
import Colors from '../views/Colors.vue'
import Foods from '../views/Foods.vue'
import GreetingsAndPhrases from '../views/GreetingsAndPhrases.vue'
import Numbers from '../views/Numbers.vue'
import WritingSystem from '../views/WritingSystem.vue'


// Define routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/Colors',
    name: 'Colors',
    component: Colors,
  },
  {
    path: '/Foods',
    name: 'Foods',
    component: Foods,
  },
  {
    path: '/GreetingsAndPhrases',
    name: 'GreetingsAndPhrases',
    component: GreetingsAndPhrases,
  },
  {
    path: '/Numbers',
    name: 'Numbers',
    component: Numbers,
  },
  {
    path: '/WritingSystem',
    name: 'WritingSystem',
    component: WritingSystem,
  }
]

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

export default router
